import React from 'react';
/**
 * Renders a child or children if any of the `names` are contained in `available`
 *
 * Common use case: An api endpoint tells the front end which fields to display
 *   By wrapping a field in <AvailableField> and feeding in the name and available names
 *   the backend can effectively decide which fields to show and which to hide
 *
 * @example
 * <AvailableField names={['first_name']} available={['first_name', 'last_name']}>
 *   <span>this is rendered as first_name is available</span>
 * </AvailableField>
 *
 * <AvailableField names={['middle_name']} available={['first_name', 'last_name']}>
 *   <span>this is not rendered as middle_name is not available</span>
 * </AvailableField>
 */

var AvailableField = function AvailableField(_ref) {
  var _ref$available = _ref.available,
      available = _ref$available === void 0 ? [] : _ref$available,
      children = _ref.children,
      _ref$names = _ref.names,
      names = _ref$names === void 0 ? [] : _ref$names;
  return available !== null && available !== void 0 && available.length && names.every(function (name) {
    return available.includes(name);
  }) ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
};

export { AvailableField };